export default __webpack_public_path__ + "static/media/chatting-app.39f6918c.png";